// @mui
import { Typography, Stack, Box, Avatar } from "@mui/material";
//
import { StyledRoot, StyledSectionBg, StyledContent } from "./styles";
import { Outlet, useLocation } from "react-router";
import { COMPANY_NAME } from "src/config";
import Logo from "src/components/logo";
import { Helmet } from "react-helmet-async";

// ----------------------------------------------------------------------

export default function GuestLayout() {
  const { pathname } = useLocation();
  return (
    <StyledRoot>
      <Helmet>
        <title> {COMPANY_NAME}</title>
      </Helmet>
      <Box sx={{ position: "absolute", left: 10, top: 10 }}>
        {!["/login", "/registration", "/otp-verify"].includes(pathname) && (
          <Logo />
        )}
      </Box>

      <StyledContent
        sx={{ p: !["/login", "/registration"].includes(pathname) ? 0 : 1 }}
      >
        {" "}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column-reverse", md: "row" }, // Mobile to Web Layout Change
            margin: "auto",
            boxShadow: 3,
            borderRadius: 2,
            p: 3,
            bgcolor: "background.paper",
            gap: 3,
          }}
        >
          {" "}
          <Box
            sx={{
              bgcolor: "grey.100",
              p: 2, // Adjust padding for mobile and web
              display: "flex",
              flexDirection: "column",
              borderRadius: 2, // Adjust border radius for mobile and web
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                bgcolor: "primary.main",
                width: 25,
                height: 25,
                borderRadius: "50%",
              }}
            />

            {/* Bold Title and Subheader */}
            <Typography variant="h4" my={2}>
              Unlock Your Earning Potential with Nivesh Hindustan
            </Typography>
            <Typography color="grey.500" fontSize={14} mb={4}>
              Our sign-up process is seamless and takes just 2 minutes to get
              you started.
            </Typography>

            {/* Grey Light Box */}
            <Box
              sx={{
                bgcolor: "grey.300",
                p: 2,
                borderRadius: 2,
              }}
            >
              <Typography variant="body2" mb={1}>
                "Nivesh Himdustan has completely transformed my financial
                journey. I started earning rewards and commissions within my
                first week!”
              </Typography>
              <Stack direction="row" alignItems="center" spacing={1} mt={3}>
                <Avatar sx={{ width: 24, height: 24 }} />
                <Typography variant="subtitle2" fontWeight="bold">
                  Subhash Kapoor, Retired Govt. Employee
                </Typography>
              </Stack>
            </Box>
          </Box>
          <Stack sx={{ width: 1, height: "fit-content" }}>
            <Outlet />
          </Stack>
        </Box>
      </StyledContent>
      <StyledSectionBg />
    </StyledRoot>
  );
}
